// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `   .login-page {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
  }
  
  .login-form {
    background-color: white;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    padding: 20px;
    width: 400px;
  }
  
  .login-header {
    font-size: 32px;
    text-align: center;
    margin-bottom: 20px;
    color: #333;
  }
  
  .form-group {
    margin-bottom: 15px;
  }
  
  .form-label {
    display: block;
    font-size: 16px;
    margin-bottom: 5px;
    color: #333;
  }
  
  .form-input {
    width: 100%;
    height: 40px;
    padding: 5px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 5px;
    box-sizing: border-box;
  }
  
  .form-input:focus {
    outline: none;
    border-color: #2a9d8f;
  }
  
  .error-message {
    color: #e63946;
    font-size: 14px;
    margin-top: 5px;
  }
  
  .success-message {
    color: #2a9d8f;
    font-size: 14px;
    margin-top: 5px;
  }

  .loading-spinner {
    border: 4px solid #f3f3f3;
    border-top: 4px solid #3498db;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    animation: spin 2s linear infinite;
  }

  .loading-text {
    font-size: 1.2rem;
    margin-right: 0.5rem;
  }
  
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  
  
  .login-button {
    display: block;
    width: 100%;
    height: 40px;
    font-size: 16px;
    color: #fff;
    background-color: #2a9d8f;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  
  .login-button:hover {
    background-color: #21867a;
  }
  
  @media only screen and (max-width: 480px) {
    .login-form {
      width: 100%;
      padding: 10px;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/pages/Login/Login.css"],"names":[],"mappings":"GAAG;IACC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;IAClB,uCAAuC;IACvC,aAAa;IACb,YAAY;EACd;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,qBAAqB;EACvB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kCAAkC;EACpC;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;;EAGA;IACE,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;EACpC;;;EAGA;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE;MACE,WAAW;MACX,aAAa;IACf;EACF","sourcesContent":["   .login-page {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n  }\n  \n  .login-form {\n    background-color: white;\n    border-radius: 5px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n    padding: 20px;\n    width: 400px;\n  }\n  \n  .login-header {\n    font-size: 32px;\n    text-align: center;\n    margin-bottom: 20px;\n    color: #333;\n  }\n  \n  .form-group {\n    margin-bottom: 15px;\n  }\n  \n  .form-label {\n    display: block;\n    font-size: 16px;\n    margin-bottom: 5px;\n    color: #333;\n  }\n  \n  .form-input {\n    width: 100%;\n    height: 40px;\n    padding: 5px;\n    font-size: 16px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    box-sizing: border-box;\n  }\n  \n  .form-input:focus {\n    outline: none;\n    border-color: #2a9d8f;\n  }\n  \n  .error-message {\n    color: #e63946;\n    font-size: 14px;\n    margin-top: 5px;\n  }\n  \n  .success-message {\n    color: #2a9d8f;\n    font-size: 14px;\n    margin-top: 5px;\n  }\n\n  .loading-spinner {\n    border: 4px solid #f3f3f3;\n    border-top: 4px solid #3498db;\n    border-radius: 50%;\n    width: 20px;\n    height: 20px;\n    animation: spin 2s linear infinite;\n  }\n\n  .loading-text {\n    font-size: 1.2rem;\n    margin-right: 0.5rem;\n  }\n  \n  \n  @keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n  }\n  \n  \n  .login-button {\n    display: block;\n    width: 100%;\n    height: 40px;\n    font-size: 16px;\n    color: #fff;\n    background-color: #2a9d8f;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n  }\n  \n  .login-button:hover {\n    background-color: #21867a;\n  }\n  \n  @media only screen and (max-width: 480px) {\n    .login-form {\n      width: 100%;\n      padding: 10px;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
